export const PricingQuestion = [
  {
    question: "How does the 14 days free trial works?",
    answer:
      "AAfter you sign up for Pavelify free trial, you will get all features of the pro plan for 14 days. During these 14 days you will be able to test all features of Pavelify and decide which plan is best for you."
  },
  {
    question: "What happens after my free trial ends",
    answer:
      "After the end of your 14 days free trial you can purchase any plan you decide on. You can also choose to downgrade to the free plan. "
  },
  {
    question: "Can I upgrade or downgrade my subscription?",
    answer:
      "Yes, you can upgrade or downgrade your subscription any time you wish to. You can upgrade from lower to higher plans or downgrade from higher to lower plans anytime."
  },
  {
    question: "What types of payment do you accept?",
    answer: "We accept Visa, Mastercard, American Express, Discover and Paypal."
  }
];
